var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9989 11.2668C11.503 11.2668 11.9346 11.0872 12.2937 10.7282C12.6527 10.3692 12.8322 9.9376 12.8322 9.43343C12.8322 8.92926 12.6527 8.49767 12.2937 8.13864C11.9346 7.77961 11.503 7.6001 10.9989 7.6001C10.4947 7.6001 10.0631 7.77961 9.70407 8.13864C9.34504 8.49767 9.16553 8.92926 9.16553 9.43343C9.16553 9.9376 9.34504 10.3692 9.70407 10.7282C10.0631 11.0872 10.4947 11.2668 10.9989 11.2668ZM10.9989 18.0043C12.8627 16.2932 14.2454 14.7386 15.1468 13.3407C16.0482 11.9428 16.4989 10.7015 16.4989 9.61676C16.4989 7.95149 15.968 6.58794 14.9062 5.52614C13.8443 4.46433 12.5419 3.93343 10.9989 3.93343C9.4558 3.93343 8.15337 4.46433 7.09157 5.52614C6.02976 6.58794 5.49886 7.95149 5.49886 9.61676C5.49886 10.7015 5.94955 11.9428 6.85094 13.3407C7.75233 14.7386 9.13497 16.2932 10.9989 18.0043ZM10.9989 20.4334C8.53914 18.3404 6.70199 16.3963 5.4874 14.6011C4.27282 12.806 3.66553 11.1445 3.66553 9.61676C3.66553 7.3251 4.40268 5.4994 5.87699 4.13968C7.35129 2.77996 9.05858 2.1001 10.9989 2.1001C12.9391 2.1001 14.6464 2.77996 16.1207 4.13968C17.595 5.4994 18.3322 7.3251 18.3322 9.61676C18.3322 11.1445 17.7249 12.806 16.5103 14.6011C15.2957 16.3963 13.4586 18.3404 10.9989 20.4334Z",
    fill: "#4A4A4A",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2b69a6a6e6002de68a75ff41aa32dc89.svg";
export { ForwardRef as ReactComponent };